import { streem } from 'streem-sdk-protobuf';
import { invariant } from '@streem/toolbox';
export class ToolInteractionEngine {
    constructor(roomSession) {
        this.roomSession = roomSession;
        this.active = false;
    }
    handleMouseInteractionEvent(evt, tool) {
        invariant(tool === 'LASER' || tool === 'MARKER', 'ToolInteractionEngine can only handle LASER and MARKER tools');
        if (evt.buttons.primary && evt.inFrame) {
            this.active = true;
            this.roomSession.tools.updateTool(tool, streem.room.ToolEventType.TOOL_EVENT_TYPE_MOVE, {
                xPercent: evt.xPercent * 100,
                yPercent: evt.yPercent * 100,
            });
        }
        else if ((!evt.buttons.primary || !evt.inFrame) && this.active) {
            this.active = false;
            this.roomSession.tools.updateTool(tool, streem.room.ToolEventType.TOOL_EVENT_TYPE_HIDE);
        }
    }
}
//# sourceMappingURL=tool_interaction_engine.js.map